import { Serializable } from '../../../../core/models/serializable';
import { CommonLookupItem } from '../../../../shared/models/common-lookup-item.model';
import { TransactionOptionItem } from './transaction-list-filter.model';

export class TransactionEditSubmitDataModel
  implements Serializable<TransactionEditSubmitDataModel>
{
  fromObject(object: any): TransactionEditSubmitDataModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    let result = {
      payerAccount: this.payerAccount,
      InvoiceAmount: this.invoiceAmount,
      PaymentType: this.paymentType,
      TransactionRecordId: this.transactionRecordId,
    };

    return result;
  }

  public transactionRecordId: number;
  public payerAccount: TransactionOptionItem;
  public invoiceAmount: number;
  public paymentType: number;
}
